// dpendencies
import { graphql } from 'gatsby';
import { FunctionComponent, useEffect } from 'react';
import AOS from 'aos';
import { Provider } from 'react-redux';

// style
import 'aos/dist/aos.css';

// components
import Layout from '@components/Layout';
import { MainProfile } from '@components/Profile';
import PostLink from '@components/Main/PostLink';
import configureStore from '@stores/index';

const store = configureStore();

// props
interface IProps {
  data: {
    allMarkdownRemark: {
      edges: Array<{
        node: {
          id: string;
          frontmatter: {
            author?: string;
            categories?: string;
            cover?: string;
            date: string;
            slug: string;
            tags?: string;
            title: string;
          }
        }
      }>;
    };
  };
}

// components
const { MainContent } = Layout;

const IndexPage: FunctionComponent<IProps> = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => {

  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date)
    .map(edge => <li key={edge.node.id}><PostLink post={edge.node} /></li>);

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Provider store={store}>
      <Layout>
        {/* main content */}
        <MainContent>
          <MainProfile />
          <ul className="recent-posts">
            {Posts}
          </ul>
        </MainContent>
      </Layout>
    </Provider>
  );
};

export const pageQuery = graphql`
  query {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
            title
            author
            categories
            cover
          }
        }
      }
    }
  }
`;

export default IndexPage;
